import { action, computed, makeObservable, observable, toJS } from 'mobx';
import moment from 'moment';
import Store from './Store';
import { INDEXEDB_STORAGE } from '@/util/StorageUtil';

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */
export default class LogStore extends Store {
    logs = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            logs: observable,
            removerLogsAntigos: action,
            objetoLocalStorage: computed,
            registrarRequisicao: action,
            registrarErro: action
        });
    }

    get storageType() {
        return INDEXEDB_STORAGE;
    }

    get nomeStorage() {
        return this.objetoLocalStorage.nomeStore;
    }

    inicializar() {
        super.inicializar();
        this.removerLogsAntigos();
    }

    removerLogsAntigos() {
        let dataLimite = moment().subtract(7, 'days');
        this.logs = this.logs.filter((log) => moment(log.data, 'DD/MM/YYYY HH:mm:ss.SSS', true).isAfter(dataLimite));
    }

    get objetoLocalStorage() {
        return {
            nomeStore: 'LogStore',
            logs: this.logs ? this.logs.slice() : []
        };
    }

    get usuarioLogado() {
        return this.rootStore.usuarioStore && this.rootStore.usuarioStore.usuario;
    }

    get dataAtualFormatada() {
        return moment().format('DD/MM/YYYY HH:mm:ss.SSS');
    }

    registrarRequisicao(requisicao) {
        this.logs.push({ data: this.dataAtualFormatada, usuario: this.usuarioLogado, requisicao: requisicao });
    }

    registrarErro(erro) {
        this.logs.push({ data: this.dataAtualFormatada, usuario: this.usuarioLogado, erro: erro });
        let usuario = toJS(this.usuarioLogado);
        if (usuario) {
            usuario.token = undefined;
        }
        console.error('ERRO:\n' + JSON.stringify(erro) + '\nUSUARIO:\n' + JSON.stringify(usuario));
    }
}
